exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-iframe {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    padding-bottom: 56.25%;\n  }\n\n  .p-iframe iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/administrativo/painel-controle-gerencial/painel-controle-gerencial.component.css
// module id = ../../../../../src/app/area-restrita/administrativo/painel-controle-gerencial/painel-controle-gerencial.component.css
// module chunks = main